import image11 from "../../assets/images/image11.jpg";
import image10 from "../../assets/images/image10.jpg";
import image15 from "../../assets/images/image15.jpg";
import image6 from "../../assets/images/image6.jpg";
import image8 from "../../assets/images/image8.jpg";
import image20 from "../../assets/images/imageR.jpg";
import image12 from "../../assets/images/image12.jpg";
import image17 from "../../assets/images/image17.jpg";
import image5 from "../../assets/images/image5.jpg";
import image13 from "../../assets/images/image13.jpg";

export const talents = [
  {
    name: "Jensen Harris",
    image: image11,
  },
  {
    name: "Micheal Montero",
    image: image10,
  },
  {
    name: "Cho KeeYong",
    image: image15,
  },
  {
    name: "Bolton Harris",
    image: image6,
  },
  {
    name: "Josephine Nyongo",
    image: image8,
  },
  {
    name: "Almena Ludwig",
    image: image20,
  },
  {
    name: "Leyla Stones",
    image: image12,
  },
  {
    name: "LOVE",
    image: image17,
  },
  {
    name: "Sandra Puleng",
    image: image5,
  },
  {
    name: "Anna Bettlin",
    image: image13,
  },
];
